import { Endpoint } from "shared/utils/endpoints";
import { TransactionType } from "shared/utils/enum";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetAllTransactions = ({
  page,
  limit,
  type,
}: {
  page: number;
  limit: number;
  type?: TransactionType;
}) => {
  return HTTP_CLIENT.get(
    Endpoint.transactions.getAll +
      `?page=${page}&limit=${limit}${type ? `&type=${type}` : ""}`
  );
};

const PayoutService = (id: number) => {
  return HTTP_CLIENT.patch(
    Endpoint.transactions.payout.replace(":id", String(id))
  );
};

export { GetAllTransactions, PayoutService };
